import React from 'react';
import PropTypes from 'prop-types';

import ProductPropertyTab, { PropertyList } from '../../molecules/product-detail-accordion';

const HowToUse = (props) => {
  if (!props.product) return null;

  const instructions = props.product?.product_properties?.filter(
    (property) => property.property_name === 'How to Use'
  );

  if (!instructions || instructions.length === 0) return null;

  return (
    <ProductPropertyTab title="How to Use">
      <PropertyList element="ul" like="paragraph-2">
        {
          instructions.map((item) =>
            // eslint-disable-next-line react/no-danger
            <li key={item.id} dangerouslySetInnerHTML={{ __html: item.value }} />)
        }
      </PropertyList>
    </ProductPropertyTab>
  );
};

HowToUse.propTypes = {
  product: PropTypes.object.isRequired
};

export default HowToUse;
